import Axios from "axios";
import store from "@/store";
import { buildRouteTreeOrder, sortRoutesByTreeOrder } from "@/services/routeOrdering";
const ROOT_ROUTE_ORDER_KEY = "root";
const emptyLocalRouteOrder = () => ({ version: 1, parents: {} });
let cachedLocalRouteOrder = emptyLocalRouteOrder();
let localRouteOrderLoaded = false;
let localRouteOrderRequest;
//Local route names 'must' start with _ underscore.
const localRoutesRaw = [
    {
        path: "/admin/groups",
        name: "_adminGroups",
        component: () => import("@/pages/admin/groups.vue"),
        meta: {
            title: "Groups Admin"
        }
    },
    {
        path: "/admin/promos",
        name: "_adminPromos",
        component: () => import("@/pages/admin/promos.vue"),
        meta: {
            title: "Promos Admin"
        }
    },
    {
        path: "/admin/files",
        name: "_adminFiles",
        component: () => import("@/pages/admin/files.vue"),
        meta: {
            title: "Files Admin"
        }
    },
    {
        path: "/admin/images",
        name: "_adminImages",
        component: () => import("@/pages/admin/images.vue"),
        meta: {
            title: "Images Admin"
        }
    },
    {
        path: "/search",
        name: "_Search",
        component: () => import("@/pages/search.vue"),
        meta: {
            title: "Search"
        }
    },
    {
        path: "/mcl/assignments/my",
        name: "_AssignmentsMy",
        component: () => import("@/pages/mcl/assignments.vue"),
        props: { myAssignments: true },
        meta: {
            title: "My Assignments",
            hideDrawer: true
        }
    },
    {
        path: "/mcl/assignments/location",
        name: "_AssignmentsMyLocation",
        component: () => import("@/pages/mcl/assignments.vue"),
        props: { myLocation: true },
        meta: {
            title: "My Location Assignments",
            hideDrawer: true
        }
    },
    {
        path: "/mcl/assignments/all",
        name: "_AssignmentsAll",
        component: () => import("@/pages/mcl/assignments.vue"),
        props: true,
        meta: {
            title: "All Assignments",
            hideDrawer: true
        }
    },
    {
        path: "/mcl/assignments/:Id",
        name: "_assignmentDetail",
        component: () => import("@/pages/assignment/assignment.vue"),
        meta: {
            title: "Assignment Detail"
        }
    },
    {
        path: "/mcl/assignments/:Id/blf",
        name: "_assignmentBLF",
        component: () => import("@/pages/assignment/blf.vue"),
        meta: {
            title: "Leadership Consulting",
            hideDrawer: true
        }
    },
    {
        path: "/mcl/assignments/report",
        name: "_ReportsAssignments",
        component: () => import("@/pages/mcl/reports/assignments.vue"),
        props: true,
        meta: {
            title: "Advanced Assignment Search",
            hideDrawer: true
        }
    },
    {
        path: "/mcl/companies/my",
        name: "_CompaniesMy",
        component: () => import("@/pages/mcl/companies.vue"),
        props: { myCompanies: true },
        meta: {
            title: "My Companies",
            hideDrawer: true
        }
    },
    {
        path: "/mcl/companies/location",
        name: "_CompaniesMyLocation",
        component: () => import("@/pages/mcl/companies.vue"),
        props: { myLocation: true },
        meta: {
            title: "My Location Companies",
            hideDrawer: true
        }
    },
    {
        path: "/mcl/companies/all",
        name: "_Companies",
        component: () => import("@/pages/mcl/companies.vue"),
        props: true,
        meta: {
            title: "All Companies",
            hideDrawer: true
        }
    },
    {
        path: "/mcl/companies/:Id",
        name: "_companyDetail",
        component: () => import("@/pages/company/company.vue"),
        meta: {
            title: "Company Detail",
            hideFromNav: true
        }
    },
    {
        path: "/mcl/companies/:Id/admin",
        name: "_companyAdmin",
        component: () => import("@/pages/company/admin/admin.vue"),
        meta: {
            title: "Company Admin"
        }
    },
    {
        path: "/mcl/companies/:Id/webtab/full",
        name: "_companyWebTab",
        component: () => import("@/pages/company/webtab/full.vue"),
        meta: {
            title: "Company Webtab"
        }
    },
    {
        path: "/mcl/companies/:Id/invenias/dedupe",
        name: "_companyMerge",
        component: () => import("@/pages/company/invenias/dedupe.vue"),
        meta: {
            title: "Company Merge",
            frame: true,
            hideFromNav: true,
            allowedGroups: ["DedupeAccess"]
        }
    },
    {
        path: "/mcl/companies/invenias/dedupe",
        name: "_companyInveniasMerge",
        component: () => import("@/pages/company/invenias/dedupe.vue"),
        meta: {
            title: "Invenias Company Merge",
            frame: true,
            hideFromNav: true,
            allowedGroups: ["DedupeAccess"]
        }
    },
    {
        path: "/mcl/companies/report",
        name: "_ReportsCompanies",
        component: () => import("@/pages/mcl/reports/companies.vue"),
        props: true,
        meta: {
            title: "Advanced Company Search",
            hideDrawer: true
        }
    },
    {
        path: "/mcl/dashboard",
        name: "_Dashboard",
        component: () => import("@/pages/mcl/dashboard.vue"),
        props: true,
        meta: {
            title: "Dashboard"
        }
    },
    /*
        {
            path: "/mcl/reports/financial",
            name: "_ReportsFinancial",
            component: () => import("@/pages/mcl/reports/financial.vue"),
            meta: {
                title: "Financial Report",
                hideDrawer: true
            }
        },
    */
    {
        path: "/directory/licenses/report",
        name: "_ReportsLicenses",
        component: () => import("@/pages/mcl/reports/licenses.vue"),
        meta: {
            title: "License Report",
            hideDrawer: true
        }
    },
    {
        path: "/directory/boydenians",
        name: "_Boydenians",
        component: () => import("@/pages/directory/boydenians.vue"),
        meta: {
            title: "Boydenians",
            hideDrawer: true
        }
    },
    {
        path: "/directory/boydenians/:Id",
        name: "_partnerProfile",
        component: () => import("@/pages/profile/profile.vue"),
        meta: {
            title: "Boydenian"
        },
        props: route => ({
            userId: route.params.Id
        })
    },
    {
        path: "/directory/boydenians/profile",
        name: "_userProfile",
        component: () => import("@/pages/profile/profile.vue"),
        meta: {
            title: "Your Profile"
        }
    },
    {
        path: "/directory/boydenians/report",
        name: "_ReportsUsers",
        component: () => import("@/pages/mcl/reports/users.vue"),
        meta: {
            title: "Boydenian Report",
            hideDrawer: true
        }
    },
    {
        path: "/directory/locations",
        name: "_Locations",
        component: () => import("@/pages/directory/locations.vue"),
        meta: {
            title: "Locations",
            hideDrawer: true
        }
    },
    {
        path: "/directory/location/:Id",
        name: "_locationDetail",
        component: () => import("@/pages/location/location.vue"),
        meta: {
            title: "Location"
        },
        props: route => ({
            locationId: route.params.Id
        })
    },
    {
        path: "/directory/licenses",
        name: "_Licenses",
        component: () => import("@/pages/directory/licenses.vue"),
        meta: {
            title: "Licenses",
            hideDrawer: true
        }
    },
    {
        path: "/directory/license/:Id",
        name: "_licenseDetail",
        component: () => import("@/pages/license/license.vue"),
        meta: {
            title: "License",
            hideDrawer: true
        },
        props: route => ({
            licenseId: route.params.Id
        })
    },
    {
        path: "/directory/locations/report",
        name: "_ReportsLocations",
        component: () => import("@/pages/mcl/reports/locations.vue"),
        meta: {
            title: "Location Report",
            hideDrawer: true
        }
    },
    {
        path: "/learn",
        name: "_learnMore",
        component: () => import("@/pages/learnMore.vue"),
        meta: {
            title: "Learn More"
        }
    },
    {
        path: "/report/:stub",
        name: "_reportRedirect",
        component: () => import("@/pages/report.vue"),
        meta: {
            title: "Loading Report"
        }
    },
    {
        path: "/daxtra",
        name: "_daxtraLanding",
        component: () => import("@/pages/daxtra.vue"),
        meta: {
            title: "Daxtra AI Search"
        }
    },
    {
        path: "/assessment",
        name: "_assessment",
        component: () => import("@/pages/assessment/assessment.vue"),
        meta: {
            title: "Assessment"
        }
    },
    {
        path: "/invenias/company/admin",
        name: "_inveniasCompanyAdmin",
        component: () => import("@/pages/invenias/company/admin.vue"),
        meta: {
            title: "Invenias Company Admin",
            allowedGroups: ["DedupeAccess"]
        }
    },
    {
        path: "/invenias/company/:Id/webtab/full",
        name: "_inveniasCompanyWebtab",
        component: () => import("@/pages/invenias/company/webtab.vue"),
        meta: {
            title: "Company",
            frame: true,
            allowedGroups: ["DedupeAccess"]
        }
    },
    {
        path: "/invenias/person/:Id/webtab/full",
        name: "_inveniasPersonWebtab",
        component: () => import("@/pages/invenias/person/webtab.vue"),
        meta: {
            title: "Person",
            frame: true,
            allowedGroups: ["DedupeAccess"]
        }
    }
];
const getLocalRoutes = (router, forceUpdate) => {
    const storedRoutes = store.getters.localRoutes;
    if (!forceUpdate && storedRoutes && storedRoutes.length > 0) {
        return storedRoutes;
    }
    const normalized = localRoutesRaw.map(o => {
        if (o.path.includes(":"))
            return undefined;
        const location = {
            name: o.name,
            path: o.path
        };
        return router.resolve(location);
    }).filter((o) => o != null);
    store.dispatch("setLocalRoutes", normalized);
    return normalized;
};
const normalizeRoutePath = (path) => {
    const normalized = "/" + path.split("/").filter(Boolean).join("/");
    return normalized === "/" ? normalized : normalized.replace(/\/$/, "");
};
const getParentRoutePath = (path) => {
    const parts = normalizeRoutePath(path).split("/").filter(Boolean);
    parts.pop();
    return parts.length > 0 ? "/" + parts.join("/") : "";
};
const getRouteOrderKey = (route) => {
    if (route._isLocal)
        return `local:${route.VueRouterName}`;
    if (route.UUID)
        return `webcomand:${route.UUID}`;
    return `webcomand-name:${route.VueRouterName}`;
};
const getStoredLocalRouteOrder = async (forceRefresh = false) => {
    if (localRouteOrderLoaded && !forceRefresh)
        return cachedLocalRouteOrder;
    if (localRouteOrderRequest)
        return localRouteOrderRequest;
    localRouteOrderRequest = Axios.get("api/v2/routes/local-order", {
        baseURL: process.env.VUE_APP_API
    }).then(response => {
        const stored = response.data;
        if (stored?.version !== 1 || !stored.parents || typeof stored.parents !== "object") {
            throw new Error("The server returned an invalid local route order document.");
        }
        cachedLocalRouteOrder = stored;
        localRouteOrderLoaded = true;
        return cachedLocalRouteOrder;
    }).finally(() => {
        localRouteOrderRequest = undefined;
    });
    return localRouteOrderRequest;
};
const getStoredLocalRouteOrderOrDefault = async () => {
    try {
        return await getStoredLocalRouteOrder();
    }
    catch (err) {
        console.error("Failed to load the global local route ordering.", err);
        return cachedLocalRouteOrder;
    }
};
const applyStoredLocalRouteOrder = (routes, storedOrder, parentKey = ROOT_ROUTE_ORDER_KEY) => {
    const placements = storedOrder[parentKey] || [];
    if (placements.length > 0) {
        const localRoutes = new Map(routes.filter(route => route._isLocal).map(route => [getRouteOrderKey(route), route]));
        const orderedRoutes = routes.filter(route => !route._isLocal);
        placements.forEach(placement => {
            const localRoute = localRoutes.get(placement.route);
            if (!localRoute)
                return;
            const afterIndex = placement.after
                ? orderedRoutes.findIndex(route => getRouteOrderKey(route) === placement.after)
                : -1;
            const beforeIndex = placement.before
                ? orderedRoutes.findIndex(route => getRouteOrderKey(route) === placement.before)
                : -1;
            if (afterIndex >= 0) {
                orderedRoutes.splice(afterIndex + 1, 0, localRoute);
            }
            else if (beforeIndex >= 0) {
                orderedRoutes.splice(beforeIndex, 0, localRoute);
            }
            else {
                orderedRoutes.push(localRoute);
            }
            localRoutes.delete(placement.route);
        });
        orderedRoutes.push(...localRoutes.values());
        routes.splice(0, routes.length, ...orderedRoutes);
    }
    routes.forEach(route => {
        applyStoredLocalRouteOrder(route.Children || [], storedOrder, getRouteOrderKey(route));
    });
};
/**
 * Builds the route hierarchy shown by the navigation editor. Local Vue routes are
 * local placeholders; their synthetic IDs keep draggable rows stable and they
 * are removed before an order is sent to webCOMAND.
 */
const buildAdminRouteTree = (remoteRoutes, storedOrder = cachedLocalRouteOrder.parents) => {
    const tree = JSON.parse(JSON.stringify(remoteRoutes));
    const routesByPath = new Map();
    const indexRemoteRoutes = (routes, parentPath = "") => {
        routes.forEach(route => {
            route.Children = route.Children || [];
            const path = normalizeRoutePath(`${parentPath}/${route.VueRouterPath || ""}`);
            routesByPath.set(path, route);
            indexRemoteRoutes(route.Children, path);
        });
    };
    indexRemoteRoutes(tree);
    const localRoutes = localRoutesRaw
        .map((route, index) => ({ route, index }))
        .filter(({ route }) => typeof route.path === "string" && !route.path.includes(":"))
        .sort((a, b) => {
        const aDepth = a.route.path.split("/").filter(Boolean).length;
        const bDepth = b.route.path.split("/").filter(Boolean).length;
        return aDepth - bDepth || a.index - b.index;
    });
    localRoutes.forEach(({ route }) => {
        const path = normalizeRoutePath(route.path);
        const parentPath = getParentRoutePath(path);
        const parent = routesByPath.get(parentPath);
        const name = String(route.name || path);
        const localRoute = {
            UUID: `-${name}`,
            Title: String(route.meta?.title || name),
            VueRouterName: name,
            VueRouterPath: path.split("/").filter(Boolean).pop() || "",
            Parent: parent?.UUID ? { UUID: parent.UUID } : undefined,
            Children: [],
            _isLocal: true
        };
        if (parent) {
            (parent.Children ||= []).push(localRoute);
        }
        else {
            tree.push(localRoute);
        }
        routesByPath.set(path, localRoute);
    });
    applyStoredLocalRouteOrder(tree, storedOrder);
    return tree;
};
const saveLocalRouteOrder = async (routes) => {
    const parents = {};
    const captureOrder = (siblings, parentKey = ROOT_ROUTE_ORDER_KEY) => {
        const placements = siblings
            .map((route, index) => ({ route, index }))
            .filter(({ route }) => route._isLocal)
            .map(({ route, index }) => {
            const previousRoute = index > 0 ? siblings[index - 1] : undefined;
            const nextWebComandRoute = siblings.slice(index + 1).find(candidate => !candidate._isLocal);
            return {
                route: getRouteOrderKey(route),
                after: previousRoute ? getRouteOrderKey(previousRoute) : undefined,
                before: nextWebComandRoute ? getRouteOrderKey(nextWebComandRoute) : undefined
            };
        });
        if (placements.length > 0)
            parents[parentKey] = placements;
        siblings.forEach(route => captureOrder(route.Children || [], getRouteOrderKey(route)));
    };
    captureOrder(routes);
    try {
        const stored = { version: 1, parents };
        const response = await Axios.post("api/v2/routes/local-order", stored, {
            baseURL: process.env.VUE_APP_API
        });
        cachedLocalRouteOrder = response.data;
        localRouteOrderLoaded = true;
        return true;
    }
    catch (err) {
        console.error("Failed to save the global local route ordering.", err);
        return false;
    }
};
const getCombinedRouteTreeOrder = (remoteRoutes, storedOrder = cachedLocalRouteOrder.parents) => {
    return buildRouteTreeOrder(buildAdminRouteTree(remoteRoutes, storedOrder));
};
const getWebComandRouteTree = (routes) => {
    return routes
        .filter(route => !route._isLocal)
        .map(route => {
        route.Children = getWebComandRouteTree(route.Children || []);
        return route;
    });
};
const evaluateString = (s, route) => {
    const matches = s.match(/{{.*?}}/g);
    if (!matches)
        return s;
    let title = s;
    const buffer = [];
    for (let i = 0; i < matches.length; i++) {
        buffer[i] = [matches[i], matches[i].replace("{{", "").replace("}}", "").trim()];
        const paramName = buffer[i][1];
        const paramValue = route.params[paramName];
        title = title.replace(buffer[i][0], paramValue);
    }
    return title;
};
const findChildRecord = (route, name) => {
    if (route.VueRouterName && route.VueRouterName === name)
        return route;
    if (route.Children) {
        for (const child of route.Children) {
            const r = findChildRecord(child, name);
            if (r)
                return r;
        }
    }
    return false;
};
const findRecordByUUID = (route, uuid) => {
    if (route.UUID && route.UUID === uuid)
        return route;
    if (route.Children) {
        for (const child of route.Children) {
            const r = findRecordByUUID(child, uuid);
            if (r)
                return r;
        }
    }
    return false;
};
const _isObject = (obj) => {
    return obj instanceof Object && obj.constructor === Object;
};
const _extractParams = (s) => {
    const matches = s.match(/:[^\d]\w+/g);
    if (!matches)
        return [];
    const params = [];
    for (const match of matches) {
        const param = match.substring(1);
        params.push(param);
    }
    return params;
};
const _normalize = (item) => {
    if (item === undefined || item === null)
        return true;
    if (_isObject(item)) {
        for (const key of Object.keys(item)) {
            const value = item[key];
            if (value && key === "VueRouterPath") {
                const params = _extractParams(value);
                if (params.length > 0) {
                    item._params = params;
                }
            }
            else {
                if (_normalize(value)) {
                    delete item[key];
                }
                else {
                    if (value === "0") {
                        item[key] = false;
                    }
                    else if (value === "1") {
                        item[key] = true;
                    }
                }
            }
        }
    }
    else if (Array.isArray(item)) {
        for (const child of item) {
            _normalize(child);
        }
    }
    return false;
};
const _addIcons = (routes) => {
    for (const child of routes) {
        switch (child.VueRouterName) {
            case "apps":
                child._icon = {
                    type: "fas",
                    name: "th"
                };
                break;
            case "boyden":
                child._icon = {
                    type: "file",
                    src: "boyden_circle.svg"
                };
                break;
            case "mcl":
                child._icon = {
                    type: "fas",
                    name: "chart-bar"
                };
                break;
            case "directory":
                child._icon = {
                    type: "fas",
                    name: "users"
                };
                break;
            case "practices":
                child._icon = {
                    type: "fas",
                    name: "window-restore"
                };
                break;
            case "guides":
                child._icon = {
                    type: "fas",
                    name: "presentation"
                };
                break;
            case "initiatives":
                child._icon = {
                    type: "fas",
                    name: "bullhorn"
                };
                break;
        }
    }
};
const collapseRoutes = (routes) => {
    let collapsed = [];
    routes.forEach(r => {
        const _r = { ...r };
        const children = r.children;
        delete _r["children"];
        collapsed.push(_r);
        if (children && children.length > 0) {
            collapsed = collapsed.concat(collapseRoutes(children));
        }
    });
    return collapsed;
};
const getRoutes = async (refreshCache = false, updateStore = true) => {
    const response = await Axios.get("api/v2/routes", {
        baseURL: process.env.VUE_APP_API,
        params: { refresh: refreshCache }
    });
    const routes = response.data;
    routes.forEach(child => {
        _normalize(child);
    });
    _addIcons(routes);
    if (updateStore) {
        store.dispatch("setRoutes", routes);
    }
    return routes;
};
const buildRemoteRoutes = (remoteRoutes, combinedRouteOrder) => {
    const root = [];
    let routeTreeOrder = combinedRouteOrder?.size || 0;
    const _flattenRoute = (routeObj, parentPath) => {
        const currentPath = parentPath + "/" + routeObj.VueRouterPath;
        root.push({
            component: () => import("@/pages/main.vue"),
            path: currentPath,
            name: routeObj.VueRouterName,
            meta: {
                title: routeObj.Title,
                breadcrumbTitle: routeObj.BreadcrumbTitle,
                uuid: routeObj.UUID,
                status: routeObj.Status,
                doNotOpen: !!routeObj.DoNotOpen,
                excludeFromNav: !!routeObj.ExcludeFromNav,
                hasFile: !!routeObj.HasFile,
                FileJSON: routeObj.FileJSON,
                redirectLink: routeObj.RedirectLink,
                downloadBtn: routeObj.DownloadBtn,
                routeTreeOrder: combinedRouteOrder?.get(routeObj.VueRouterName) ?? routeTreeOrder++,
                remoteRoute: true
            }
        });
        if (routeObj.Children && routeObj.Children.length > 0) {
            for (const child of routeObj.Children) {
                _flattenRoute(child, currentPath);
            }
        }
    };
    remoteRoutes.forEach(routeObj => {
        _flattenRoute(routeObj, "");
    });
    return root;
};
const buildRoutes = async (refreshCache = false) => {
    const [remoteRoutes, localRouteOrder] = await Promise.all([
        getRoutes(refreshCache),
        getStoredLocalRouteOrderOrDefault()
    ]);
    const combinedRouteOrder = getCombinedRouteTreeOrder(remoteRoutes, localRouteOrder.parents);
    const root = buildRemoteRoutes(remoteRoutes, combinedRouteOrder);
    localRoutesRaw.forEach(routeObj => {
        root.push({
            ...routeObj,
            meta: {
                ...routeObj.meta,
                routeTreeOrder: combinedRouteOrder.get(String(routeObj.name))
            }
        });
    });
    const routes = [
        {
            path: "/",
            name: "mainTemplate",
            component: () => import(/* webpackChunkName: "mainTemplate" */ "@/pages/mainTemplate.vue"),
            children: root,
        },
        {
            path: "/admin",
            name: "adminTemplate",
            component: () => import(/* webpackChunkName: "mainTemplate" */ "@/pages/adminTemplate.vue"),
            children: [
                {
                    path: "routes",
                    name: "_adminRoutes",
                    component: () => import("@/pages/admin/routes.vue"),
                    meta: {
                        title: "Routes"
                    }
                }
            ]
        },
        {
            path: "/login",
            name: "login",
            component: () => import("@/pages/login.vue")
        },
        {
            path: "/noaccess",
            name: "noaccess",
            component: () => import("@/pages/noaccess.vue")
        }
    ];
    return routes;
};
const refreshRoutes = async (refreshCache = false) => {
    const router = store.getters.router;
    const [remoteRoutes, localRouteOrder] = await Promise.all([
        getRoutes(refreshCache, false),
        getStoredLocalRouteOrderOrDefault()
    ]);
    const combinedRouteOrder = getCombinedRouteTreeOrder(remoteRoutes, localRouteOrder.parents);
    const routes = buildRemoteRoutes(remoteRoutes, combinedRouteOrder);
    router.getRoutes()
        .filter(route => route.meta.remoteRoute && route.name)
        .forEach(route => router.removeRoute(route.name));
    routes.forEach(route => router.addRoute("mainTemplate", route));
    router.getRoutes()
        .filter(route => route.name && combinedRouteOrder.has(String(route.name)))
        .forEach(route => {
        route.meta.routeTreeOrder = combinedRouteOrder.get(String(route.name));
    });
    store.dispatch("setRoutes", remoteRoutes);
    const currentRoute = router.currentRoute.value || router.currentRoute;
    const currentPath = currentRoute.fullPath;
    const refreshedLocation = router.resolve(currentPath);
    if (refreshedLocation.matched.length > 0) {
        await router.replace(currentPath);
    }
    else {
        const rootPath = "/" + currentRoute.path.split("/").filter(Boolean)[0];
        if (router.resolve(rootPath).matched.length > 0) {
            await router.replace(rootPath);
        }
    }
};
const getPathArray = (route) => {
    const fullPath = route.matched[route.matched.length - 1].path;
    const arr = fullPath.split("/");
    if (arr[0] === "") {
        arr.shift();
    }
    if (arr.length > 0 && arr[arr.length - 1] === "") {
        arr.pop();
    }
    return arr;
};
const getFullPathArray = (route, reusedPathArray) => {
    const pathArray = reusedPathArray ?? getPathArray(route);
    const newArray = [
        "/" + pathArray[0]
    ];
    for (let i = 1; i < pathArray.length; i++) {
        if (pathArray[i] !== "") {
            newArray[i] = newArray[i - 1] + "/" + pathArray[i];
        }
        else {
            break;
        }
    }
    return newArray;
};
const getRouteDetailArray = (route, routes) => {
    if (route.path === "/")
        return [];
    const pathArray = getPathArray(route);
    const fullPathArray = getFullPathArray(route, pathArray);
    const mainRoutes = routes.find((o) => {
        return o.name === "mainTemplate";
    })?.children;
    const newArray = [];
    for (let i = 0; i < pathArray.length; i++) {
        const path = pathArray[i];
        const fullPath = fullPathArray[i];
        if (i === pathArray.length - 1 && route.name.startsWith("_")) {
            newArray.push({
                name: route.name,
                title: route.meta?.title || "",
                path: route.path
            });
        }
        else {
            if (!mainRoutes)
                return [];
            const matchedRoute = mainRoutes.find((o) => {
                return o.path === fullPathArray[i];
            });
            if (matchedRoute) {
                const meta = matchedRoute.meta;
                newArray.push({
                    name: matchedRoute.name,
                    title: meta.title,
                    breadcrumbTitle: meta.breadcrumbTitle,
                    path: matchedRoute.path,
                    status: meta.status,
                    doNotOpen: meta.doNotOpen,
                    excludeFromNav: meta.excludeFromNav,
                    hasFile: meta.hasFile,
                    FileJSON: meta.FileJSON,
                    redirectLink: meta.RedirectLink,
                    downloadBtn: meta.DownloadBtn,
                });
            }
        }
    }
    return newArray;
};
const routeHasNullParams = (route) => {
    const keys = Object.keys(route.params);
    for (const key of keys) {
        if (!route.params[key]) {
            return true;
        }
    }
    return false;
};
export { getLocalRoutes, getRoutes, buildRoutes, refreshRoutes, buildAdminRouteTree, getStoredLocalRouteOrder, saveLocalRouteOrder, getWebComandRouteTree, sortRoutesByTreeOrder, evaluateString, findChildRecord, findRecordByUUID, getPathArray, getRouteDetailArray, getFullPathArray, routeHasNullParams };
